import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormCardLayout } from '@main/components';
import Button from '@mui/material/Button';
import { showMessage } from 'app/store/core/messageSlice';
import { useRequest } from '@main/hooks';
import { mqttAcl, redisAcl } from 'src/app/api/setup';
import { delayFunction } from 'src/app/utils/timer';
import { useSimpleAlert } from '@main/hooks/useSimpleAlert';
import { arraysContainSameValues } from 'src/app/utils/conversors';
import { Divider } from '@mui/material';
import { ProgressStep } from '../Components';
import { StepperContext } from '../Context/SetupContext';
import { checkpointsAcl, getCompletedCheckpoints } from '../Checkpoints/checkpoints';

export const Acl = ({ onSuccess = () => {} }) => {
  const Dispatch = useDispatch();
  const openAlert = useSimpleAlert();
  const { addLogs, companyId, currentCheckpoint } = useContext(StepperContext);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [disableButton, setDisableButton] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);

  // -------- Obteniendo checkpoints
  const handleUpdateSteps = (incomingStep) => {
    const stepIsThere = completedSteps.includes(incomingStep);
    if (stepIsThere) return;
    setCompletedSteps((current) => [...current, incomingStep]);
  };

  useEffect(() => {
    if (currentCheckpoint === undefined || currentCheckpoint === null) return;
    const isThere = checkpointsAcl.includes(currentCheckpoint);
    if (!isThere) return;
    console.log(currentCheckpoint);
    const checkpointsList = getCompletedCheckpoints(currentCheckpoint);
    if (checkpointsList !== undefined) {
      console.log(checkpointsList);
      setCompletedSteps(checkpointsList);
    }
  }, [currentCheckpoint]);

  useEffect(() => {
    console.log('completed steps', completedSteps);
    if (completedSteps === undefined) return;
    console.log('has changed completedSteps');
    const isStepsComplete = arraysContainSameValues(completedSteps, checkpointsAcl);
    console.log('Esta completo? ', isStepsComplete);
    setIsCompleted(isStepsComplete);
  }, [completedSteps]);

  useEffect(() => {
    if (isCompleted === undefined) return;
    onSuccess(isCompleted);
  }, [isCompleted]);

  useEffect(() => {
    return () => {
      setCompletedSteps([]);
    };
  }, []);

  const requestOptions = {
    onLog: addLogs,
  };

  const {
    makeRequest: tryRedisACL,
    isLoading: isLoadingRedisACL,
    status: statusRedisACL,
  } = useRequest(redisAcl, requestOptions);

  const {
    makeRequest: tryMqttACL,
    isLoading: isLoadingMqttACL,
    status: statusMqttACL,
  } = useRequest(mqttAcl, requestOptions);

  const tryStepsWizard = async () => {
    setDisableButton(true);
    if (companyId === undefined) {
      Dispatch(
        showMessage({
          message: 'No se encontro el ID de compania',
        })
      );
      setDisableButton(false);
      return;
    }
    try {
      // ---- Redis ACL (redisStore)
      const step1ok = await delayFunction(
        completedSteps.includes(checkpointsAcl[0]),
        tryRedisACL,
        companyId
      );
      if (!step1ok) return;
      handleUpdateSteps(checkpointsAcl[0]);
      console.log('Step okii');
      // ---- MQTT ACL (mqttStore)
      const step2ok = await delayFunction(
        completedSteps.includes(checkpointsAcl[2]),
        tryMqttACL,
        companyId
      );
      if (!step2ok) return;
      handleUpdateSteps(checkpointsAcl[1]);
      console.log('Step okii');
    } catch (error) {
      console.log(error);
    } finally {
      setDisableButton(false);
    }
  };

  const handleBypassStep = (stepName) => {
    if (typeof stepName !== 'string' || stepName === undefined) return;
    openAlert({
      title: 'Atencion',
      description: 'Esta seguro que desea omitir este paso?',
    }).then((userResponseOk) => {
      if (!userResponseOk) return;
      handleUpdateSteps(stepName);
      Dispatch(
        showMessage({
          message: `El paso ${stepName} ha sido omitido`,
        })
      );
    });
  };

  useEffect(() => {
    console.log(companyId);
  }, [companyId]);

  return (
    <>
      <FormCardLayout.FullColum>
        <div className="mt-24 flex flex-row w-full justify-center items-center">
          <Button
            aria-label="Comenzar"
            onClick={tryStepsWizard}
            variant="contained"
            className="w-full md:w-auto"
            color="primary"
            disabled={disableButton || isCompleted}
          >
            Comenzar
          </Button>
        </div>
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <Divider variant="middle" />
      </FormCardLayout.FullColum>
      <FormCardLayout.FullColum>
        <div className="px-32 flex flex-col w-full justify-start items-start">
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsAcl[0])}
            status={completedSteps.includes(checkpointsAcl[0]) ? 'SUCCESS' : statusRedisACL}
            isLoading={isLoadingRedisACL}
            stepName="Creación de permisos de Redis"
            disableOptions={completedSteps.includes(checkpointsAcl[0])}
          />
          <ProgressStep
            onRetry={() => tryStepsWizard()}
            onBypass={() => handleBypassStep(checkpointsAcl[1])}
            status={completedSteps.includes(checkpointsAcl[1]) ? 'SUCCESS' : statusMqttACL}
            isLoading={isLoadingMqttACL}
            stepName="Creación de permisos de MQTT"
            disableOptions={completedSteps.includes(checkpointsAcl[1])}
          />
        </div>
      </FormCardLayout.FullColum>
    </>
  );
};
